import FormWrapper from '../../../layout/FormWrapper/FormWrapper';
import FormLayout from '../../../layout/FormLayout/FormLayout';
import Input from '../../../../../components/Input/Input';

const StorageViewGeneralPartner = ({ selectedData, onClose }: any) => {
    return (
        <FormWrapper isSmall={true} mode={'view'}>
            <FormLayout title={'General Partner'} description={'Here is the general partner.'} onClose={onClose}>
                <Input readOnly value={selectedData.gpName}>
                    Name
                </Input>
                <Input readOnly value={selectedData.fullName}>
                    Full name
                </Input>
                <Input readOnly value={selectedData.domicileName}>
                    Domicile
                </Input>
                <Input readOnly value={selectedData.legalForm}>
                    Legal form
                </Input>
            </FormLayout>
        </FormWrapper>
    );
};

export default StorageViewGeneralPartner;
